import t from"graphql-tag";import{apolloQuery as e,apolloMutate as n}from"../graphql/index.js";import{FilterComponentsDocument as a,GetComponentDocument as o,GetAllComponentsDocument as s,GetComponentByUuidDocument as i,InsertComponentDocument as r,InsertComponentsDocument as m,DeleteComponentDocument as p,UpdateComponentDocument as u,FilterExclusiveComponentByUserDocument as h,GetExclusiveComponentsDocument as d,GetUuidByMetaDocument as c}from"../types/generated.js";const l=t`
  query getComponentsByUUIDs($uuids: [uuid!]!, $space: uuid) {
    component(
      where: {
        uuid: { _in: $uuids }
        status: { _eq: ACTIVE }
        _or: [
          { type: { _eq: PUBLIC } }
          {
            type: { _in: [EXCLUSIVE] }
            meta: { _contains: { assigned_to: [{ spaces: [$space] }] } }
          }
        ]
      }
    ) {
      id
      name
      type
      uuid
      meta
      schema
      info
    }
  }
`;var y=new class{constructor(){this.filterComponents=t=>e({query:a,variables:t}).then((t=>t.data)),this.getComponent=t=>e({query:o,variables:t}).then((t=>t.data.component)),this.getAllComponents=()=>e({query:s}).then((t=>t.data.component)),this.getComponentByUUID=t=>e({query:i,variables:t}).then((t=>t.data.component.shift())),this.getComponentsByUUIDs=t=>e({query:l,variables:t}).then((t=>t.data.component||[])),this.insertComponent=t=>n({mutation:r,variables:t}).then((t=>t.data.component)),this.insertComponents=t=>n({mutation:m,variables:t}).then((t=>t.data.insert_component.returning.map((t=>t.id)))),this.deleteComponent=t=>n({mutation:p,variables:t}).then((t=>t.data.component)),this.updateComponent=t=>n({mutation:u,variables:t}).then((t=>t.data.component)),this.filterExclusiveComponentByUser=t=>e({query:h,variables:t}).then((t=>t.data)),this.getExclusiveComponents=t=>e({query:d,variables:t}).then((t=>t.data.component)),this.getUUIDByMeta=t=>e({query:c,variables:t}).then((t=>t.data.component))}};export{y as default};
